import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import normalize from 'json-api-normalizer';
import { useSession } from '@/hooks/useSession';
import { baseURL } from '@/services/api';
import { PATHS } from '@/routes/paths';

function QrLogin() {
  const { code } = useParams();
  const navigate = useNavigate();
  const { setSession } = useSession();
  const started = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const authenticate = async () => {
      try {
        // axios puro: não envia o token de uma sessão anterior.
        const response = await axios.post(`${baseURL()}/qr_authenticate`, { code }, { timeout: 15000 });
        const normalized = normalize(response.data);
        Object.keys(normalized).forEach(key => {
          normalized[key] = normalized[key][Object.keys(normalized[key])].attributes;
        });
        setSession(normalized);
        navigate('/', { replace: true });
      } catch (e) {
        if (e.response?.status === 401) {
          toast.error('QR Code inválido ou expirado');
          navigate(PATHS.AUTH.LOGIN, { replace: true });
        } else if (e.response?.status === 404) {
          setError('O acesso por QR Code ainda não está disponível na API deste ambiente.');
        } else {
          setError('Não foi possível conectar à plataforma para validar o QR Code. Verifique sua conexão e tente novamente.');
        }
      }
    };

    authenticate();
  }, []);

  return (
    <main className="flex min-h-screen items-center justify-center bg-white p-6">
      <div className="max-w-md text-center">
        {error ? (
          <>
            <p role="alert">{error}</p>
            <button
              type="button"
              className="btn btn--primary mt-4"
              onClick={() => window.location.reload()}
            >
              Tentar novamente
            </button>
            <Link
              className="mt-4 block"
              to={PATHS.AUTH.LOGIN}
            >
              Ir para o login
            </Link>
          </>
        ) : (
          <p
            role="status"
            aria-live="polite"
          >
            Validando seu QR Code e acessando a plataforma…
          </p>
        )}
      </div>
    </main>
  );
}

export default QrLogin;
